import {Links} from '../interfaces';

export interface OnlineServiceConfig {
  linksField: keyof Links;
  slug: string;
  title: string;
}

export const ONLINE_SERVICES: OnlineServiceConfig[] = [
  {linksField: 'badgeUrl', slug: 'badge', title: 'Compte'},
  {linksField: 'roomServiceUrl', slug: 'roomService', title: 'Room Service'},
  {linksField: 'clickAndCollectUrl', slug: 'clickAndCollect', title: 'À emporter'},
];
